import { handleActions } from 'redux-actions';
import { clearLeftStatementContent } from 'store/actions/statement-content-actions';
import {
  resetHighlightMappedElements,
  setHighlightMappedElements,
} from 'store/actions/trial-balance/trial-balance-action';

export default handleActions(
  {
    [setHighlightMappedElements]: (state, { payload }) => {
      return { ...state, highlightMappedElements: payload };
    },
    [resetHighlightMappedElements]: () => {
      return {
        highlightMappedElements: true,
      };
    },
    [clearLeftStatementContent]: () => {
      return {
        highlightMappedElements: true,
      };
    },
  },
  {
    highlightMappedElements: true,
  },
);
